(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const switcher = document.querySelector('[data-language-switcher]');
    if (!switcher) return;

    const links = switcher.querySelectorAll('.language-link:not(.is-active)');

    const hreflangMap = new Map();
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => {
      const lang = link.getAttribute('hreflang');
      const url = link.getAttribute('href');
      if (lang && url) {
        hreflangMap.set(lang, url);
      }
    });

    links.forEach(link => {
      const targetLang = link.dataset.lang;
      const translatedUrl = hreflangMap.get(targetLang);

      if (translatedUrl) {
        link.href = translatedUrl;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
